export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]
